<template>
  <div class="skeleton-loader-container">
    <component :is="skeletonComponent" v-if="loading" v-bind="$attrs"></component>
    <slot v-else></slot>
  </div>
</template>

<script>
import CircleSkeleton from '@/components/skeleton/CircleSkeleton.vue';
import PictureSkeleton from '@/components/skeleton/PictureSkeleton.vue';

export const SKELETON_TYPES = {
  CircleSkeleton: {
    type: 'circle',
    component: CircleSkeleton,
  },
  PictureSkeleton: {
    type: 'picture',
    component: PictureSkeleton,
  },
};

const SKELETON_COMPONENT_TYPE_MAP = Object.keys(SKELETON_TYPES).reduce((acc, key) => {
  const results = acc;
  results[SKELETON_TYPES[key].type] = SKELETON_TYPES[key].component;
  return results;
}, {});

export default {
  name: 'SkeletonLoader',
  props: {
    loading: { type: Boolean, default: false },
    type: {
      type: String,
      required: true,
      default: 'title',
      validator: (value) =>
        Object.keys(SKELETON_TYPES)
          .map((key) => SKELETON_TYPES[key].type)
          .includes(value),
    },
  },
  computed: {
    skeletonComponent() {
      const component = SKELETON_COMPONENT_TYPE_MAP[this.type];
      return component;
    },
  },
};
</script>

<style lang="postcss" scoped>
.skeleton-loader-container {
  display: contents;
}
</style>
